import clsx from 'clsx';
import {FC, MouseEvent, ReactNode} from 'react';
import {Link} from 'react-router-dom';

import s from './styles.module.scss';

interface CustomLinkProps {
  to: string;
  children: ReactNode;
  external?: boolean;
  target?: '_blank' | '_self' | '_parent' | '_top';
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
}

export const CustomLink: FC<CustomLinkProps> = ({
  to,
  onClick,
  children,
  external,
  target,
  className,
}) => {
  if (external || target === '_blank') {
    return (
      <a href={to} target={target} className={clsx(s.link, className)} onClick={onClick}>
        {children}
      </a>
    );
  }

  return (
    <Link to={to} className={clsx(s.link, className)} onClick={onClick}>
      {children}
    </Link>
  );
};
